var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleeve(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "digital_wallet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m456.535 418.134c-15.52.047-29.051 10.569-32.921 25.599h-35.349v-25.599h-17.067v34.131c.008 4.709 3.823 8.526 8.532 8.535h43.879c10.796 38.352 66.01 31.608 67.054-8.535-.021-18.84-15.288-34.108-34.128-34.131zm0 51.198c-9.422-.009-17.058-7.645-17.067-17.067.924-22.642 33.203-22.642 34.134 0-.01 9.422-7.645 17.058-17.067 17.067z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.537 469.332h-43.879c-3.87-15.03-17.401-25.551-32.921-25.599-45.284 1.876-45.27 66.398 0 68.267 15.521-.047 29.052-10.57 32.921-25.601h52.411c4.709-.008 8.526-3.823 8.535-8.532v-59.733h-17.067zm-76.8 25.601c-9.422-.009-17.058-7.645-17.067-17.067.924-22.642 33.2-22.642 34.131 0-.007 9.422-7.642 17.058-17.064 17.067z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.403 444.943v-26.8h-17.076v26.8c-15.032 3.87-25.554 17.401-25.601 32.923 1.876 45.284 66.398 45.267 68.267 0-.046-15.518-10.563-29.049-25.59-32.923zm-8.527 49.99c-9.422-.009-17.058-7.645-17.067-17.067.936-22.642 33.203-22.642 34.134 0-.009 9.422-7.645 17.058-17.067 17.067z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.468 401.067c23.554-.027 42.641-19.114 42.668-42.668v-204.8c-.028-23.553-19.115-42.639-42.668-42.666h-307.198c-10.637.001-20.885 3.997-28.716 11.196-3.477 3.182-3.716 8.581-.534 12.058s8.581 3.716 12.058.534c4.685-4.317 10.821-6.718 17.192-6.726h307.198c14.133.014 25.586 11.467 25.601 25.599v51.206h-102.401c-28.277.003-51.198 22.928-51.196 51.205.003 28.274 22.922 51.193 51.196 51.196h102.401v51.198c-.015 14.133-11.468 25.586-25.601 25.601h-307.198c-10.575-.013-20.052-6.532-23.845-16.404-1.664-4.409-6.587-6.635-10.996-4.971s-6.635 6.587-4.971 10.996c6.317 16.503 22.142 27.413 39.813 27.45zm-76.8-110.933c-45.284-1.878-45.267-66.398 0-68.267h102.401v68.267z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.203 230.399c-14.129.017-25.58 11.463-25.601 25.592 1.407 33.963 49.8 33.951 51.2 0-.021-14.129-11.471-25.576-25.599-25.592zm0 34.133c-4.714.001-8.536-3.819-8.537-8.532-.001-4.714 3.819-8.536 8.532-8.537 4.714-.001 8.536 3.819 8.537 8.532v.005c-.005 4.711-3.821 8.53-8.532 8.539z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.737 93.866c15.52-.048 29.05-10.569 32.921-25.599h26.812v25.599h17.067v-34.133c-.009-4.709-3.825-8.525-8.535-8.532h-35.349c-10.787-38.355-66.005-31.608-67.05 8.532.022 18.842 15.292 34.112 34.134 34.133zm0-51.2c9.422.009 17.057 7.645 17.065 17.067-.924 22.642-33.2 22.642-34.131 0 .008-9.422 7.644-17.058 17.066-17.067z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.203 42.666h43.879c3.869 15.031 17.4 25.554 32.921 25.601 45.284-1.876 45.267-66.398 0-68.267-15.52.047-29.051 10.569-32.921 25.599h-52.413c-4.709.009-8.525 3.825-8.532 8.535v59.733h17.067v-51.201zm76.799-25.599c9.422.009 17.058 7.645 17.067 17.067-.936 22.642-33.203 22.642-34.134 0 .009-9.422 7.645-17.058 17.067-17.067z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.327 67.054v26.812h17.067v-26.8c15.03-3.87 25.551-17.401 25.599-32.921-1.876-45.284-66.398-45.27-68.267 0 .053 15.517 10.574 29.042 25.601 32.909zm8.549-49.987c9.422.009 17.058 7.645 17.067 17.067-.924 22.642-33.203 22.642-34.134 0 .009-9.422 7.645-17.058 17.067-17.067z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.136 341.332c1.455.002 2.886-.368 4.159-1.074l38.782-21.544c20.771-11.401 33.735-33.162 33.87-56.856v-80.762c-.002-2.988-1.569-5.757-4.129-7.299-49.994-30.689-108.847-22.713-145.365 0-2.555 1.544-4.117 4.313-4.117 7.299v80.762c.137 23.694 13.1 45.454 33.87 56.856l38.784 21.544c1.269.703 2.696 1.073 4.146 1.074zm-59.733-79.477v-75.838c37.195-20.454 82.27-20.454 119.465 0v75.845c-.136 17.497-9.74 33.548-25.095 41.938l-34.637 19.24-34.637-19.24c-15.356-8.391-24.961-24.444-25.095-41.943z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.604 273.067c-2.264 0-4.435-.899-6.035-2.5l-17.067-17.067c-3.332-3.332-3.332-8.735 0-12.067s8.735-3.332 12.067 0l9.704 9.704 28.362-42.537c2.616-3.922 7.916-4.98 11.837-2.365 3.922 2.616 4.98 7.915 2.365 11.837l-34.134 51.194c-1.584 2.372-4.247 3.798-7.099 3.801z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeve);
export default __webpack_public_path__ + "static/media/sleeve.6781ee5361f2f2c98df2062c154af538.svg";
export { ForwardRef as ReactComponent };